import { atom } from "recoil";
import { Calendar, Dirary } from "../types/dirary";

export const calendarListState = atom<Calendar[]>({
  key: "calendarListState",
  default: [],
});

export const calendarListStateForMatrix = atom<Calendar[]>({
  key: "calendarListStateForMatrix",
  default: [],
});
